// extracted by mini-css-extract-plugin
module.exports = {"weeksSlider":"WeeksSlider_weeksSlider__12tjz","weeks":"WeeksSlider_weeks__39tTe","weekBar":"WeeksSlider_weekBar__2gTUt"};